import classNames from 'classnames';
import React, { useState } from 'react';
import styles from './toggle-button-group.module.css';
export function ToggleButtonGroup(_a) {
    var buttons = _a.buttons, onClick = _a.onClick, defaultButtonLabel = _a.defaultButtonLabel;
    var _b = useState(defaultButtonLabel !== null && defaultButtonLabel !== void 0 ? defaultButtonLabel : buttons[0].label), activeButtonLabel = _b[0], setActiveButtonLabel = _b[1];
    function onClickHandler(buttonLabel) {
        if (activeButtonLabel === buttonLabel)
            return;
        setActiveButtonLabel(buttonLabel);
        onClick(buttonLabel);
    }
    return (React.createElement("ul", { className: classNames(styles.toggleButtonGroupWrapper, "kplr_toggleButtonGroupWrapper") }, buttons.map(function (button) {
        var _a;
        return (React.createElement("li", { key: button.label, className: classNames(styles.toggleButton, (_a = {}, _a[styles.active] = activeButtonLabel === button.label, _a)), onClick: function () { return onClickHandler(button.label); } },
            !!button.icon && React.createElement(React.Fragment, null, button.icon),
            React.createElement("span", { className: "caption2" }, button.label)));
    })));
}
export default ToggleButtonGroup;
